import React, { useEffect, useState } from "react";
import { List, Datagrid, TextField, DateField, FunctionField, SelectInput, TopToolbar, ExportButton } from "react-admin";
import { getResource, invoiceChoices, isOverdue, monthChoices } from "../common";
import { Link } from "react-router-dom";
import { downloadCSV } from 'react-admin';
import { unparse } from 'papaparse';
import CustomCreateButton from "../components/CustomeCreateButton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const InvoiceHistoryList = () => {
  const [customers, setCustomers] = useState([]);
  const [cleanHistory, setCleanHistory] = useState([]);
  const [inspectHistory, setInspectHistory] = useState([]);
  const [constructHistory, setConstructHistory] = useState([]);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };
    fetchUser();
    getHistory("cleaningHistory");
    getHistory("inspectHistory");
    getHistory("constructHistory");
  }, []);

  const getHistory = async (tableName) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_DIR}/invoiceHistory/history/${tableName}`, {
        method: "GET",
        headers: new Headers({ "Content-Type": "application/json" }),
        mode: "cors",
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch user info");
      }
      const { data } = await response.json();
      if (data) {
        console.log(data);
        if (tableName === "cleaningHistory") {
          setCleanHistory(data);
        }
        else if (tableName === "inspectHistory") {
          setInspectHistory(data);
        }
        else if (tableName === "constructHistory") {
          setConstructHistory(data);
        }
      }
    } catch (error) {
      console.error("ユーザー情報の取得に失敗しました:", error);
    }
  };

  // const customExporter = (records) => {
  //   // エクスポートするデータをカスタムフォーマットに変換
  //   const csvData = records.map(record => {
  //     const choice = invoiceChoices.find(choice => choice.id === record.invoiceCategory);
  //     return {
  //       // "請求No": String(record.number).padStart(5, "0"), 
  //       "請求対象区分": choice ? choice.name : "",
  //       "請求日": record.invoiceDate ? new Date(record.invoiceDate).toLocaleDateString() : "",
  //       "請求金額(税抜き)": record.invoiceAmount ? `${record.invoiceAmount.toLocaleString()}` : "",
  //       "支払い方法": record.payMethod ?? "",
  //       "再発行日": record.reissueDate ? new Date(record.reissueDate).toLocaleDateString() : "",
  //       "領収": record.isPay ? "済" : "",
  //       "領収日": record.receiptDate ? new Date(record.receiptDate).toLocaleDateString() : "",
  //       "顧客名": getCustomer(record.customerId) ? `${getNameAndCompanyName(getCustomer(record.customerId).surname,getCustomer(record.customerId).name,getCustomer(record.customerId).companyName)}`: "",

  //     }

  //   });
  //   const csv = "\uFEFF" + unparse(csvData, { header: true });
  //   downloadCSV(csv, `請求履歴_` + new Date().toLocaleDateString());
  // };

  const customExporter = (records) => {
    const excelData = records.map(record => {
      const choice = invoiceChoices.find(choice => choice.id === record.invoiceCategory);
      return {
        "請求対象区分": choice ? choice.name : "",
        "請求日": record.invoiceDate ? new Date(record.invoiceDate).toLocaleDateString() : "",
        "請求金額(税抜き)": record.invoiceAmount ? `${record.invoiceAmount.toLocaleString()}` : "",
        "支払い方法": record.payMethod ?? "",
        "再発行日": record.reissueDate ? new Date(record.reissueDate).toLocaleDateString() : "",
        "領収": record.isPay ? "済" : "",
        "領収日": record.receiptDate ? new Date(record.receiptDate).toLocaleDateString() : "",
        "顧客名": getCustomer(record.customerId)
          ? getCustomer(record.customerId).bukken : "",
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // 列幅設定（必要に応じて調整）
    worksheet['!cols'] = [
      { wch: 20 }, // 請求対象区分
      { wch: 15 }, // 請求日
      { wch: 18 }, // 請求金額(税抜き)
      { wch: 15 }, // 支払い方法
      { wch: 15 }, // 再発行日
      { wch: 8 },  // 領収
      { wch: 15 }, // 領収日
      { wch: 30 }, // 顧客名
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, '請求履歴');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    saveAs(blob, `請求履歴_${new Date().toLocaleDateString()}.xlsx`);
  };


  const getCustomer = (customerId) => {
    const customer = customers.find(req => req.id === customerId);
    return customer;
  }

  const CustomerFilters = [
    <SelectInput
      source="month"
      label={<span style={{ fontSize: "12px" }}>請求月</span>}
      choices={monthChoices}
      alwaysOn
      sx={{
        ".MuiInputBase-root": { height: "35px" },
        ".MuiInputBase-input": {
          fontSize: "12px"
        },
      }}
    />
  ];

  const handleRowClick = (id, basePath, record) => {
    const url = `${window.location.origin}/#/${basePath}/show/${id}`;
    const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
    window.open(url, '_blank', features);
    return false;
  };

  const CustomersActions = () => (
    <TopToolbar>
      <CustomCreateButton basePath="/invoiceHistory" />
      <ExportButton exporter={customExporter} />
    </TopToolbar>
  );

  return (
    <List filters={CustomerFilters} actions={<CustomersActions />} sort={{ field: "invoiceDate", order: "ASC" }}>
      <Datagrid rowClick={(id, basePath, record) => handleRowClick(id, basePath, record)} bulkActionButtons={false} rowStyle={(record) => isOverdue(record) ? { backgroundColor: "#FFCCCC" } : {}}>
        {/* <FunctionField source="number" label="請求No" render={(record) => {
          return String(record.number).padStart(5, "0");
        }}/> */}
        <FunctionField
          label="請求対象区分"
          render={record => {
            const choice = invoiceChoices.find(choice => choice.id === record.invoiceCategory);
            return choice ? choice.name : "";
          }}
        />
        <FunctionField
          label="請求対象"
          render={record => {
            if (record.invoiceCategory === 1) {
              const history = (cleanHistory && cleanHistory.length > 0) ? cleanHistory.find(history => history.invoceId === record.invoceId) : null;
              return history ? <Link to={`/cleanHistory/show/${history.cleaningId}`} >清掃履歴</Link> : "";
            }
            else if (record.invoiceCategory === 2) {
              const history = (inspectHistory && inspectHistory.length > 0) ? inspectHistory.find(history => history.invoceId === record.invoceId) : null;
              return history ? <Link to={`/inspectHistory/show/${history.inspectId}`} >点検履歴</Link> : "";
            }
            else if (record.invoiceCategory === 3) {
              const history = (constructHistory && constructHistory.length > 0) ? constructHistory.find(history => history.invoceId === record.invoceId) : null;
              return history ? <Link to={`/constructHistory/show/${history.constructId}`} >修理履歴</Link> : "";
            }

          }}
          onClick={(e) => e.stopPropagation()}
        />
        <DateField source="invoiceDate" label="請求日" />
        <FunctionField source="invoiceAmount" label="請求金額(税抜き)"
          render={(record) => {
            return record.invoiceAmount ? `${record.invoiceAmount.toLocaleString()}円` : ""
          }}
        />
        <TextField source="payMethod" label="支払い方法" />
        <DateField source="reissueDate" label="再発行日" />
        <FunctionField
          source="isPay"
          label="領収"
          render={(record) => {
            return record.isPay ? "領収済み" : "";
          }}
        />
        <DateField source="receiptDate" label="領収日" />
        <FunctionField
          source="customerId"
          label="顧客名"
          render={(record) => {
            const customer = getCustomer(record.customerId);
            return customer ? <Link to={`/${getResource(customer)}/show/${record.customerId}`}>{`${customer.bukken}`}</Link> : "";
          }}
          onClick={(e) => e.stopPropagation()}
        />
      </Datagrid>
    </List>
  );
}

export default InvoiceHistoryList;
